<template>
  <v-container class="py-10" fluid>
    <v-row align="center" justify="center">
      <h1>Payments</h1>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="5" lg="4" xl="4">
        <v-text-field :disabled="loadingPayments" prepend-icon="fa-search"
                      placeholder="Search by user data or payment data..." v-model="search"/>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="10" md="11" sm="12" xl="10">
        <v-data-table :loading="loadingPayments" loading-text="Loading Payments..." :headers="headers" :items="items" :search="search">
          <template v-slot:item.paymentDate="{ item }">
            <p class="my-0">{{ getDateFormatted(new Date(item.paymentDate))}}</p>
          </template>
          <template v-slot:item.amount="{ item }">
            <p class="my-0">{{ (item.plan === 'ANNUALLY_PRO')? (item.amount * 12): item.amount }} USD</p>
          </template>
          <template v-slot:item.user.id="{ item }">
            <p class="my-0">{{ item.user.id }}</p>
          </template>
          <template v-slot:item.user.firstName="{ item }">
            <p class="my-0">{{ capitalize(item.user.firstName) }} {{ capitalize(item.user.lastName) }}</p>
          </template>
          <template v-slot:item.plan="{ item }">
            <v-chip :color="getPlanColor(item.plan)" :text-color="getPlanColor(item.plan)"
                    v-text="(item.plan === 'MONTHLY_PLAN')? 'Monthly' : (item.plan === 'ANNUALLY_PRO')? 'Annually' : 'Free'" outlined/>
          </template>
          <template v-slot:item.paymentMethod="{ item }">
            <v-chip :color="getMethodColor(item.paymentMethod)" :text-color="getMethodColor(item.paymentMethod)" v-text="item.paymentMethod" outlined/>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip :color="getStatusColor(item.status)" :text-color="getStatusColor(item.status)"
                    v-text="capitalize(item.status)" outlined/>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Repository from '../../repositories/payments';
export default {
  name: "Payments",
  data() {
    return {
      loadingPayments: true,
      headers: [
        {text: 'Date', value: 'paymentDate', align: 'left', sortable: false, filterable: false},
        {text: 'User ID', value: 'user.id', align: 'left', sortable: true, filterable: true},
        {text: 'User Full Name', value: 'user.firstName', align: 'left', sortable: true, filterable: true},
        {text: 'Amount', value: 'amount', align: 'left', sortable: true, filterable: true},
        {text: 'Plan', value: 'plan', align: 'left', sortable: true, filterable: true},
        {text: 'Method', value: 'paymentMethod', align: 'left', sortable: true, filterable: true},
        {text: 'Paypal Subscription', value: 'subscriptionId', align: 'left', sortable: false, filterable: true},
        {text: 'Status', value: 'status', align: 'left', sortable: true, filterable: true},
      ],
      items: [],
      search: '',
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    items: function () {
      this.updateSubscriptionsData();
    },
  },
  methods: {
    init() {
      this.loadingPayments = true;
      Repository.allPayments().then((response) => {
        if(response.status < 400) {
          this.items = response.data;
          this.loadingPayments = false;
        }
      });
      this.updateSubscriptionsData();
    },
    updateSubscriptionsData() {
      for(let i = 0; i < this.items.length; i++)
        this.items[i].subscriptionId = this.$store.state.users.find((userDetails) => userDetails.user.id === this.items[i].user.id).subscriptionId;
    },
    getDateFormatted(date) {
      return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}
      ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    },
    getPlanColor(plan) {
      switch (plan) {
        case 'MONTHLY_PLAN':
          return '#008f4c';
        case 'ANNUALLY_PRO':
          return '#004724';
        default:
          return '#1c3153';
      }
    },
    getStatusColor(status) {
      switch (status) {
        case 'ACTIVATED':
          return '#006b39';
        case 'CREATED':
          return '#39006b';
        default:
          return '#454545';
      }
    },
    getMethodColor(method) {
      switch (method) {
        case 'ePayco checkout':
          return '#bc6900';
        case 'PayPal checkout':
          return '#00619b';
      }
    },
    capitalize(string) {
      return `${string[0].toUpperCase()}${string.slice(1, string.length).toLowerCase()}`;
    },
  }
}
</script>

<style scoped>

</style>
